import { render, staticRenderFns } from "./label-mobile.vue?vue&type=template&id=67c28f7a"
import script from "./label-mobile.vue?vue&type=script&lang=ts"
export * from "./label-mobile.vue?vue&type=script&lang=ts"
import style0 from "./label-mobile.vue?vue&type=style&index=0&id=67c28f7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports